/**
 * @generated SignedSource<<44071a893e22ad07b27df7dbf5c49608>>
 * @relayHash 1199d57946df4d620f9686f4a9a6f6c4
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ec93168954e0f0d18a2083f59037cdd5cd0ebd93d8d1dd7dfcdaf333e1412a79

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildNetworksScreenQuery$variables = {
  id: string;
};
export type GuildNetworksScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildMetadata_guild" | "GuildNetworkGuildsSection_guild" | "GuildNetworksSection_guild">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type GuildNetworksScreenQuery = {
  response: GuildNetworksScreenQuery$data;
  variables: GuildNetworksScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "transform",
    "value": {
      "dpr": 1,
      "fit": "cover",
      "h": 600,
      "w": 1200
    }
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  {
    "kind": "Literal",
    "name": "membershipStatus",
    "value": "ACCEPTED"
  }
],
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Guild",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          (v4/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "websiteUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "twitterUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instagramUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linkedinUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "youtubeUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "githubUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blueskyUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "blueskyIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildMembership",
            "kind": "LinkedField",
            "name": "myMembership",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "membershipLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "memberCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "primaryPhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "dpr",
                        "value": 3
                      },
                      {
                        "kind": "Literal",
                        "name": "fit",
                        "value": "cover"
                      },
                      {
                        "kind": "Literal",
                        "name": "h",
                        "value": 100
                      },
                      {
                        "kind": "Literal",
                        "name": "w",
                        "value": 100
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "transform"
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "colorPalette",
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "backgroundPhoto",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "transform",
                    "value": {
                      "dpr": 3,
                      "fit": "cover",
                      "h": 200,
                      "w": 500
                    }
                  }
                ],
                "kind": "ScalarField",
                "name": "transformUrl",
                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":200,\"w\":500})"
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "transform",
                "value": {
                  "dpr": 3,
                  "h": 200,
                  "w": 500
                }
              }
            ],
            "kind": "ScalarField",
            "name": "defaultBackgroundUrl",
            "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":3,\"h\":200,\"w\":500})"
          },
          (v6/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v10 = [
  "membershipStatus"
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildNetworksScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildNetworksSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildNetworkGuildsSection_guild"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildNetworksScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "primaryPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": "seoUrl",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "transform",
                        "value": {
                          "dpr": 1,
                          "fit": "contain",
                          "h": 500,
                          "w": 500
                        }
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"contain\",\"h\":500,\"w\":500})"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "backgroundPhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": "coverUrl",
                    "args": (v7/*: any*/),
                    "kind": "ScalarField",
                    "name": "transformUrl",
                    "storageKey": "transformUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":600,\"w\":1200})"
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "defaultCoverUrl",
                "args": (v7/*: any*/),
                "kind": "ScalarField",
                "name": "defaultBackgroundUrl",
                "storageKey": "defaultBackgroundUrl(transform:{\"dpr\":1,\"fit\":\"cover\",\"h\":600,\"w\":1200})"
              },
              {
                "alias": "networks",
                "args": (v8/*: any*/),
                "concreteType": "GuildsConnection",
                "kind": "LinkedField",
                "name": "rankedNetworks",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "rankedNetworks(first:12,membershipStatus:\"ACCEPTED\")"
              },
              {
                "alias": "networks",
                "args": (v8/*: any*/),
                "filters": (v10/*: any*/),
                "handle": "connection",
                "key": "GuildNetworksSection_guild_networks",
                "kind": "LinkedHandle",
                "name": "rankedNetworks"
              },
              (v6/*: any*/),
              {
                "alias": "guilds",
                "args": (v8/*: any*/),
                "concreteType": "GuildsConnection",
                "kind": "LinkedField",
                "name": "rankedNetworkGuilds",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "rankedNetworkGuilds(first:12,membershipStatus:\"ACCEPTED\")"
              },
              {
                "alias": "guilds",
                "args": (v8/*: any*/),
                "filters": (v10/*: any*/),
                "handle": "connection",
                "key": "GuildNetworkGuildsSection_guild_guilds",
                "kind": "LinkedHandle",
                "name": "rankedNetworkGuilds"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ec93168954e0f0d18a2083f59037cdd5cd0ebd93d8d1dd7dfcdaf333e1412a79",
    "metadata": {},
    "name": "GuildNetworksScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b59973868ff1b71a67d6aac302d84b7b";

export default node;
